import { InputField } from '../../UI/Input/InputField';

const AddressData = ({
  country,
  city,
  address,
  postCode,
  showModify,
  handleCountryFn,
  handleCityFn,
  handleAddressFn,
  handlePostCodeFn,
}: {
  country?: string;
  city?: string;
  address?: string;
  postCode?: string;
  showModify: boolean;
  handleCountryFn: (event: any) => void;
  handleCityFn: (event: any) => void;
  handleAddressFn: (event: any) => void;
  handlePostCodeFn: (event: any) => void;
}) => {
  return (
    <div className="mt-8 mb-8">
      <p className="text-primary text-[16px] mb-4">Address</p>
      <InputField
        label="Country"
        id="country"
        forId="country"
        type="text"
        value={country}
        className=" mb-3"
        onChange={handleCountryFn}
        readOnly={!showModify}
      />
      <InputField label="City" id="city" forId="city" type="text" value={city} className=" mb-3" onChange={handleCityFn} readOnly={!showModify} />
      <InputField
        label="Address"
        id="address"
        forId="address"
        type="text"
        value={address}
        className=" mb-3"
        onChange={handleAddressFn}
        readOnly={!showModify}
      />
      <InputField
        label="Post code"
        id="post code"
        forId="post code"
        type="text"
        value={postCode}
        className=" mb-3"
        onChange={handlePostCodeFn}
        readOnly={!showModify}
      />
    </div>
  );
};

export default AddressData;
